<div class="collapse-content" [@collapse]="open ? 'open' : 'closed'">
  <ng-content></ng-content>
</div>